export const Languages = [
  "Afar",
  "Abkhazian",
  "Avestan",
  "Afrikaans",
  "Akan",
  "Amharic",
  "Aragonese",
  "Arabic",
  "Assamese",
  "Avaric",
  "Aymara",
  "Azerbaijani",
  "Bashkir",
  "Belarusian",
  "Bulgarian",
  "Bihari languages",
  "Bislama",
  "Bambara",
  "Bengali",
  "Tibetan",
  "Breton",
  "Bosnian",
  "Catalan; Valencian",
  "Chechen",
  "Chamorro",
  "Corsican",
  "Cree",
  "Czech",
  "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
  "Chuvash",
  "Welsh",
  "Danish",
  "German",
  "Divehi; Dhivehi; Maldivian",
  "Dzongkha",
  "Ewe",
  "Greek, Modern (1453-)",
  "English",
  "Esperanto",
  "Spanish; Castilian",
  "Estonian",
  "Basque",
  "Persian",
  "Fulah",
  "Finnish",
  "Fijian",
  "Faroese",
  "French",
  "Western Frisian",
  "Irish",
  "Gaelic; Scomttish Gaelic",
  "Galician",
  "Guarani",
  "Gujarati",
  "Manx",
  "Hausa",
  "Hebrew",
  "Hindi",
  "Hiri Motu",
  "Croatian",
  "Haitian; Haitian Creole",
  "Hungarian",
  "Armenian",
  "Herero",
  "Interlingua (International Auxiliary Language Association)",
  "Indonesian",
  "Interlingue; Occidental",
  "Igbo",
  "Sichuan Yi; Nuosu",
  "Inupiaq",
  "Ido",
  "Icelandic",
  "Italian",
  "Inuktitut",
  "Japanese",
  "Javanese",
  "Georgian",
  "Kongo",
  "Kikuyu; Gikuyu",
  "Kuanyama; Kwanyama",
  "Kazakh",
  "Kalaallisut; Greenlandic",
  "Central Khmer",
  "Kannada",
  "Korean",
  "Kanuri",
  "Kashmiri",
  "Kurdish",
  "Komi",
  "Cornish",
  "Kirghiz; Kyrgyz",
  "Latin",
  "Luxembourgish; Letzeburgesch",
  "Ganda",
  "Limburgan; Limburger; Limburgish",
  "Lingala",
  "Lao",
  "Lithuanian",
  "Luba-Katanga",
  "Latvian",
  "Malagasy",
  "Marshallese",
  "Maori",
  "Macedonian",
  "Malayalam",
  "Mongolian",
  "Marathi",
  "Malay",
  "Maltese",
  "Burmese",
  "Nauru",
  "Bokmål, Norwegian; Norwegian Bokmål",
  "Ndebele, North; North Ndebele",
  "Nepali",
  "Ndonga",
  "Dutch; Flemish",
  "Norwegian Nynorsk; Nynorsk, Norwegian",
  "Norwegian",
  "Ndebele, South; South Ndebele",
  "Navajo; Navaho",
  "Chichewa; Chewa; Nyanja",
  "Occitan (post 1500)",
  "Ojibwa",
  "Oromo",
  "Oriya",
  "Ossetian; Ossetic",
  "Panjabi; Punjabi",
  "Pali",
  "Polish",
  "Pushto; Pashto",
  "Portuguese",
  "Quechua",
  "Romansh",
  "Rundi",
  "Romanian; Moldavian; Moldovan",
  "Russian",
  "Kinyarwanda",
  "Sanskrit",
  "Sardinian",
  "Sindhi",
  "Northern Sami",
  "Sango",
  "Sinhala; Sinhalese",
  "Slovak",
  "Slovenian",
  "Samoan",
  "Shona",
  "Somali",
  "Albanian",
  "Serbian",
  "Swati",
  "Sotho, Southern",
  "Sundanese",
  "Swedish",
  "Swahili",
  "Tamil",
  "Telugu",
  "Tajik",
  "Thai",
  "Tigrinya",
  "Turkmen",
  "Tagalog",
  "Tswana",
  "Tonga (Tonga Islands)",
  "Turkish",
  "Tsonga",
  "Tatar",
  "Twi",
  "Tahitian",
  "Uighur; Uyghur",
  "Ukrainian",
  "Urdu",
  "Uzbek",
  "Venda",
  "Vietnamese",
  "Volapük",
  "Walloon",
  "Wolof",
  "Xhosa",
  "Yiddish",
  "Yoruba",
  "Zhuang; Chuang",
  "Chinese",
  "Zulu"
];
